import { render, staticRenderFns } from "./RenounceButton.vue?vue&type=template&id=5f1566a8&"
import script from "./RenounceButton.ts?vue&type=script&lang=ts&"
export * from "./RenounceButton.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports